import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { BucketsPage } from '@/features/data/buckets/buckets-page';
import { ConsoleShell } from '@/features/shell/console-shell';

export const Route = createFileRoute('/$tenant/buckets/')({ component: BucketsRoute });

function BucketsRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="buckets" crumbs={[{ label: t('nav.items.buckets') }]}>
      <BucketsPage tenantId={tenant} />
    </ConsoleShell>
  );
}
